import { Component } from '@theme/component';
//@ts-ignore
import BlazeSlider from "@lib/blaze-slider";

/**
 * Product Addon Component
 * 
 * @typedef {Object} Refs
 * 
 * @extends {Component}
 */
export class ProductAddon extends Component {
  /** @type {BlazeSlider|null} */
  slider = null;

  connectedCallback() {
    super.connectedCallback();
    this.initSlider();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.destroySlider();
  }

  /**
   * Toggle addon selection
   * @param {Event} event
   */
  selectProduct(event) 
  {
    event.preventDefault();
    
    const target = /** @type {HTMLElement} */ (event.target);
    const checkbox = /** @type {HTMLInputElement} */ (
      target.closest('product-addon')?.querySelector('input[name="variantId"]')
    );

    if (!(checkbox instanceof HTMLInputElement)) {
      return;
    }

    // Toggle checkbox
    checkbox.checked = !checkbox.checked;
  }

  /**
   * Initialize the slider
   */
  initSlider() {
    const sliderSelector = this.querySelector(".blaze-slider");

    if (sliderSelector) 
    {
      this.slider = new BlazeSlider(sliderSelector, {
        all: {
          slidesToShow: 1,
          loop: true,
        },
      });
    }
  }

  /**
   * Destroy the slider instance
   */
  destroySlider() {
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
    }
  }

  /**
   * Go to the next slide
   */
  nextSlide() {
    if (this.slider) {
      this.slider.next();
    } 
  }

  /**
   * Go to the previous slide
   */
  prevSlide() {
    if (this.slider) {
      this.slider.prev();
    }
  }
}

if (!customElements.get('product-addon')) {
  customElements.define('product-addon', ProductAddon);
}